import React from 'react';
export const UserDetails = React.createContext({
	userDetails: {}
});